<div class="col">
    <div class="card card-clickable" style="max-width: 540px;">
        <div class="row row-cols-1 g-0">
            <div class="col" style="height: 200px">
                <img src="/images/placeholder.png" class="img-fluid rounded-top w-100 h-100" style="object-fit: cover;">
            </div>
            <div class="col">
                <div class="card-body">
                    <h5 class="name card-title text-nowrap">Card title</h5>
                    <div class="card-text d-flex flex-row justify-content-between">
                        <span>Total Score: <span class="fullscore"></span></span>
                        <span class="joker-text"></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</div>